import axios from 'axios'
import local from './kit/storageKit'
import constant from '../../main/assets/js/core/jsCtx'
import Vue from '../../main'
// 请求拦截
axios.interceptors.request.use(config => {
  // 1. 这个位置就请求前最后的配置
  // 2. 当然你也可以在这个位置 加入你的后端需要的用户授权信息
  let token = local.get(constant.localConstant.token)
  if (token) {
    config.headers.token = token
  }
  return config
}, error => {
  return Promise.reject(error)
});
// 响应拦截
axios.interceptors.response.use(response => {
  // 请求成功
  // 1. 根据自己项目需求定制自己的拦截
  // 2. 然后返回数据
  return response
}, error => {
  // 请求失败
  if (error && error.response) {
    switch (error.response.status) {
      case 401:
        Message.$Message.error('登录超时,请重新登录!');
        Message.$Loading.close();
        local.remove(constant.localConstant.token);
        local.remove(constant.localConstant.tabs);
        Vue.$router.replace({
          path: '/'
        });
        break;
      case 500:
        Message.$Message.error('服务器连接失败,请重试!');
        Message.$Loading.close();
        break;
      case 404:
        Message.$Message.error('请求失败,请稍后重试!');
        Message.$Loading.close();
        break;
        return Promise.reject(error)
    }
  }
})
